
Vue.mixin({
	methods: {
		showModalProfileUpdateForm(route) {
			this.$root.$emit('bv::show::modal', 'profile-form-modal');
			this.EventBus.$emit('showProfileForm', route);
		},
		showModalDocUpdateForm(id, countryId, name) {
			this.$root.$emit('bv::show::modal', 'doc-form-modal');
			this.EventBus.$emit('showDocIdForm', id, countryId, name);
		},
	}
});


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/profile.js